import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { ApBaseClass } from 'webcommon/shared';
import { FcItemModalContext, FcItemModalMode } from '../../../models/index';

@Component({
  providers: [ApAlertService],
  selector: 'fc-general-modal',
  templateUrl: './fc-general-modal.component.html',
  styleUrls: ['./fc-general-modal.component.less'],
})
export class FcGeneralModalComponent extends ApBaseClass implements OnInit {
  @Input() baseId = '';
  @Input() fcModalItemContext: FcItemModalContext | null = null;
  @Input() form: FormGroup;
  @Input() isSaving = false;
  @Input() isSaveDisabled = true;
  // TODO: this doesn't seem right - the mode should have been provided in the fcModalItemContext above instead.
  // It seems like this component was used as a generic modal container
  // instead of its intended purpose of creating/editing an item from a find control.
  @Input() mode?: FcItemModalMode;
  @Input() isLoading = false;
  @Input() listItemName = '';
  @Output() isSubmitted = new EventEmitter<boolean>();
  @Output() saveForm = new EventEmitter<FormGroup>();
  @Output() cancelForm = new EventEmitter<void>();

  public fcItemModalModeEnum = FcItemModalMode;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.fcModalItemContext) {
      if (this.fcModalItemContext.mode === FcItemModalMode.Modify) {
        // Adding 0 width whitespace to prevent error occured while trying to translate name with '$&' in it
        this.fcModalItemContext.selectedFindItemName = this.fcModalItemContext.selectedFindItemName?.split('$&').join('$\u200b&');
      }
    }
  }

  public onSave(): void {
    this.saveForm.emit();
  }

  public onCancel(): void {
    this.cancelForm.emit();
  }
}
